import ClubsPage from "./ClubsPage";

export default ClubsPage;
